import { apiFetch } from '../lib/api';
import type {
  AdminClubResponse,
  AdminFishTypeResponse,
  AdminLureTypeResponse,
  AdminSpotResponse,
  AdminUserResponse,
  AdminUsersListResponse,
  CatchesListResponse,
} from '../types/api';

export function listAdminClubs(): Promise<AdminClubResponse[]> {
  return apiFetch<AdminClubResponse[]>('/api/admin/clubs');
}

export function listAdminUsers(page = 1, pageSize = 50): Promise<AdminUsersListResponse> {
  return apiFetch<AdminUsersListResponse>(`/api/admin/users?page=${page}&pageSize=${pageSize}`);
}

export function listAdminCatches(params: {
  userId?: string;
  clubId?: number;
  from?: string;
  to?: string;
  page?: number;
  pageSize?: number;
}): Promise<CatchesListResponse> {
  const qs = new URLSearchParams();
  if (params.userId) qs.set('userId', params.userId);
  if (params.clubId != null) qs.set('clubId', String(params.clubId));
  if (params.from) qs.set('from', params.from);
  if (params.to) qs.set('to', params.to);
  if (params.page != null) qs.set('page', String(params.page));
  if (params.pageSize != null) qs.set('pageSize', String(params.pageSize));
  const query = qs.toString();
  return apiFetch<CatchesListResponse>(`/api/admin/catches${query ? `?${query}` : ''}`);
}

export function setSuperAdmin(userId: string, enabled: boolean): Promise<void> {
  return apiFetch<void>(
    `/api/admin/users/${encodeURIComponent(userId)}/super-admin`,
    { method: 'PATCH', body: { enabled } },
  );
}

export function updateUser(
  userId: string,
  body: { email?: string; newPassword?: string; unlock?: boolean },
): Promise<AdminUserResponse> {
  return apiFetch<AdminUserResponse>(
    `/api/admin/users/${encodeURIComponent(userId)}`,
    { method: 'PUT', body },
  );
}

export function listAdminSpots(): Promise<AdminSpotResponse[]> {
  return apiFetch<AdminSpotResponse[]>('/api/admin/spots');
}

export function createSpot(body: { name: string; latitude: number; longitude: number }): Promise<AdminSpotResponse> {
  return apiFetch<AdminSpotResponse>('/api/admin/spots', { method: 'POST', body });
}

export function updateSpot(id: number, body: { name: string; latitude: number; longitude: number }): Promise<AdminSpotResponse> {
  return apiFetch<AdminSpotResponse>(`/api/admin/spots/${id}`, { method: 'PUT', body });
}

export function setSpotActive(id: number, active: boolean): Promise<void> {
  return apiFetch<void>(`/api/admin/spots/${id}/active`, { method: 'PATCH', body: { active } });
}

export function listAdminFishTypes(): Promise<AdminFishTypeResponse[]> {
  return apiFetch<AdminFishTypeResponse[]>('/api/admin/fishtypes');
}

export function createFishType(body: { name: string }): Promise<AdminFishTypeResponse> {
  return apiFetch<AdminFishTypeResponse>('/api/admin/fishtypes', { method: 'POST', body });
}

export function updateFishType(id: number, body: { name: string }): Promise<AdminFishTypeResponse> {
  return apiFetch<AdminFishTypeResponse>(`/api/admin/fishtypes/${id}`, { method: 'PUT', body });
}

export function setFishTypeActive(id: number, active: boolean): Promise<void> {
  return apiFetch<void>(`/api/admin/fishtypes/${id}/active`, { method: 'PATCH', body: { active } });
}

export function listAdminLureTypes(): Promise<AdminLureTypeResponse[]> {
  return apiFetch<AdminLureTypeResponse[]>('/api/admin/luretypes');
}

export function createLureType(body: { name: string }): Promise<AdminLureTypeResponse> {
  return apiFetch<AdminLureTypeResponse>('/api/admin/luretypes', { method: 'POST', body });
}

export function updateLureType(id: number, body: { name: string }): Promise<AdminLureTypeResponse> {
  return apiFetch<AdminLureTypeResponse>(`/api/admin/luretypes/${id}`, { method: 'PUT', body });
}

export function setLureTypeActive(id: number, active: boolean): Promise<void> {
  return apiFetch<void>(`/api/admin/luretypes/${id}/active`, { method: 'PATCH', body: { active } });
}
